import React, { createContext, useContext, useState } from "react";
import { IBannerData, IEventBannerContext } from "../exports/interfaces";

const EventBannerContext = createContext<IEventBannerContext>({
  eventBannerData: [],
  setEventBannerData: () => null,
});
export const useEventBannerContext = () => useContext(EventBannerContext);

export const EventBannerProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [eventBannerData, setEventBannerData] = useState<IBannerData[]>([]);

  return (
    <EventBannerContext.Provider value={{ eventBannerData, setEventBannerData }}>
      {children}
    </EventBannerContext.Provider>
  );
};